var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{attrs:{"title":"Guess Data","area":this.$props.area}},[_c('GuessWords'),_c('GuessSubs'),_c('GuessGames')],1)}
var staticRenderFns = []

export { render, staticRenderFns }